import '../styles/Footer.scss'

type Props = {}

const Footer = (props: Props) => {
  return (
    <div className="footer-container">
      <p className="footer-label">FetchGoat 2025</p>

    </div>
  )
}

export default Footer